﻿window.cBuilderEmailWidgetVide = function(option) {
    var Me = this
    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    this.mGetButton = function () {
        return null
    }

    //this.mCreateElement = function () {
    //    option.element = $("<tr class='widget dxwidgetvide'>")
    //    $("<!-- DEBUT VIDE -->").appendTo(option.element)
    //    var $Td = $("<td valign='top' style='padding:0px;margin:0px;' class='tdwidget widgetheightauto'>").appendTo(option.element)
    //    var $Table = $("<table class='tablewidget' border='0' cellpadding='0' cellspacing='0' width='100%' style='width:100%;height:50px;'/>").appendTo($Td)
    //    var $Tr = $("<tr/>").appendTo($Table)
    //    var $Td = $("<td valign='top' width='100%' style='width:100%;margin:0px;word-break:normal;vertical-align:middle;font-weight:bold;opacity:0.2;font-size:12px;height:50px;padding:5px' class='bodywidget' jsoncssdata='{}'><div style='width:100%;height:40px;border:1px dashed black;display:flex;align-items:center;justify-content:center;text-align:center;'>Déposer le contenu ici</div></td>").appendTo($Tr)
    //    $("<!-- FIN VIDE -->").appendTo(option.element)
    //}

    this.mCreateElement = function () {
        option.element = this.mGetElement()
    }

    this.mGetElement = function () {
        var ele = $("<tr class='widget dxwidgetvide'>")
        $("<!-- DEBUT VIDE -->").appendTo(ele)
        var $Td = $("<td valign='top' style='padding:0px;margin:0px;' class='tdwidget widgetheightauto'>").appendTo(ele)
        var $Table = $("<table class='tablewidget' border='0' cellpadding='0' cellspacing='0' width='100%' style='width:100%;height:50px;'/>").appendTo($Td)
        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td valign='top' width='100%' style='width:100%;margin:0px;word-break:normal;vertical-align:middle;font-weight:bold;opacity:0.2;font-size:12px;height:50px;padding:5px' class='bodywidget' jsoncssdata='{}'><div style='width:100%;height:40px;border:1px dashed black;display:flex;align-items:center;justify-content:center;text-align:center;'>Déposer le contenu ici</div></td>").appendTo($Tr)

        var $TablePaddingBorder = $("<table  border='0' cellspacing='0' cellpadding='0' style='width:100%'/>").appendTo($Td)
        var $Tr = $("<tr/>").appendTo($TablePaddingBorder)
        var $Td = $("<td class='contenuwidget tdpaddingborderwidget'/>").appendTo($Tr)

        $("<!-- FIN VIDE -->").appendTo(ele)
        return ele
    }

    this.nom = "Colonne vide"
    this.icone = ""

    this.mAddCtrlSaisie = function (contentElement) {
        contentElement.empty()
    }

    this.mUpdateCss = function () { }

}